import { Pipe, PipeTransform } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { DateTime } from 'luxon';
import { Moment } from 'moment';

import { SpaSimpleProductSummaryDTO } from '@api';

@UntilDestroy()
@Pipe({
  name: 'hasProductValidTime',
  standalone: false,
})
export class HasProductValidTimePipe implements PipeTransform {
  transform(product: SpaSimpleProductSummaryDTO, selectedDate: Moment): boolean {
    if (!product?.openingHoursStart) {
      return true;
    }

    return (
      DateTime.now() <=
      DateTime.fromFormat(
        selectedDate.format('YYYY-MM-DD') + ' ' + product.openingHoursStart,
        'yyyy-MM-dd HH:mm:ss',
      ).plus({
        minutes: product.duration,
      })
    );
  }
}
